import { ItemDetailsTemplate } from '@/interfaces/item-details-template.inteface';
import http from '@/services/http';

export default {
    async getAll() {
        const response = await http.get(`/item_details_templates`);
        return response.data;
    },
    async create(template: ItemDetailsTemplate) {
        const response = await http.post(`/item_details_templates`, template);
        return response.data;
    },
    async update(template: ItemDetailsTemplate) {
        const response = await http.put(`/item_details_templates/${template.uuid}`, template);
        return response.data;
    },
    async delete(uuid: string) {
        const response = await http.delete(`/item_details_templates/${uuid}`);
        return response.data;
    }
};
